const auctionCheckbox = '#product_auction_enabled';

function bindAuctionCreationCheckbox() {
  $(document).on('click', auctionCheckbox, toggleCheckBoxes);
}

function toggleCheckBoxes() {
  const offers = $('.offers_enabled').find('input, label');
  const auctionOptions = $('.auction-options');

  if ($(auctionCheckbox).is(':checked')) {
    auctionOptions.show();
    auctionOptions.find('input').prop('required', 'required').addClass('required');
    offers.prop('checked', false);
    offers.prop('disabled', true);
  } else {
    offers.prop('disabled', false);
    auctionOptions.hide();
    auctionOptions.find('input').prop('required', false).removeClass('required');
  }
}

function init() {
  bindAuctionCreationCheckbox();
  toggleCheckBoxes();
}

export default {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/auctions/create.js